module.exports = __webpack_public_path__ + "img/abstract.b967305d.svg";